import type { Route } from "./+types/podcast-episode";
import Page from "../pages/PodcastEpisode";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { liveOffers } from "../lib/offers";
export async function loader() {
  const [episodes, offers] = await Promise.all([legacy.podcasts(), liveOffers()]);
  return { episodes, offers };
}
export function meta({ data, params }: Route.MetaArgs) {
  const ep = data?.episodes.find((e: any) => e.slug === params.slug);
  const tags: any[] = pageMeta({
    title: `${ep?.title ?? "Gazar Breakpoint"} | Podcast`,
    description: ep?.description ?? "An episode of Gazar Breakpoint.",
    path: `/podcast/${params.slug}`,
    image: (ep?.image as any)?.url,
    type: "article",
  });
  // schema.org VideoObject → eligible for video rich results in Google.
  if (ep?.youtubeId || ep?.youtube) {
    tags.push({
      "script:ld+json": {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        name: ep.title,
        description: ep.description ?? "",
        thumbnailUrl: (ep.image as any)?.url,
        uploadDate: ep.publishedAt,
        embedUrl: ep.youtubeId ? `https://www.youtube.com/embed/${ep.youtubeId}` : undefined,
        contentUrl: ep.youtube || undefined,
        publisher: { "@type": "Person", name: "Ehsan Gazar" },
      },
    });
  }
  return tags;
}
export default function R({ loaderData }: Route.ComponentProps) { return <Page episodes={loaderData.episodes} offers={loaderData.offers} />; }
